module.exports = "/_next/static/images/logo-desktop-b2b-new-4bf731becd3f168315a2c70b4c5a74a7.svg";